import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { clearAuthToken, isTokenExpired } from "../helper/utils";
import { setUser } from "../redux/slice/auth/authSlice";
import { AUTH_TOKEN } from "../constants";

export default function AuthGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const token = localStorage.getItem(AUTH_TOKEN);

  useEffect(() => {
    if (token && !isTokenExpired()) {
      const decodedUser = jwt_decode(token);
      dispatch(setUser(decodedUser));
      console.log("Decoded User:", decodedUser);
      if (location.pathname === "/" && decodedUser?.role === "admin") {
        navigate("/admin");
      }
    } else {
      clearAuthToken();
      dispatch(setUser(null));
      navigate("/");
    }
  }, [location.pathname, dispatch, navigate, token]); // listen to route changes

  return children;
}
